<div class="content-container">
    <ion-header no-border mode="md">
        <ion-toolbar class="top-color" mode="md" title-with-slogan>
            <ion-title>
                <h2>
                    <ion-text color="primary"> {{ 'generic.valueConfig' | translate }} </ion-text>
                </h2>
                <p>{{ 'manageVersion.slider' | translate | uppercase }}</p>
            </ion-title>
            <ion-buttons slot="end">
                <ion-button (click)="dismiss()" mode="ios">
                    <ion-icon class="bp-close" name="delete"></ion-icon>
                </ion-button>
            </ion-buttons>
            <div class="lang-selection">
                <ion-button fill="clear" mode="ios" class="ion-no-padding" (click)="changeSelectedLanguage('pt-BR')" [ngClass]="{ 'active': language === 'pt-BR' }">
                    PT
                </ion-button>
                <ion-button fill="clear" mode="ios" class="ion-no-padding" (click)="changeSelectedLanguage('en-US')" [ngClass]="{ 'active': language === 'en-US' }">
                    EN
                </ion-button>
                <ion-button fill="clear" mode="ios" class="ion-no-padding" (click)="changeSelectedLanguage('es-ES')" [ngClass]="{ 'active': language === 'es-ES' }">
                    ES
                </ion-button>
            </div>
        </ion-toolbar>
    </ion-header>

    <ion-content>
        <mat-tab-group>
            <mat-tab [label]="'Generic.LabelSettings' | translate">
                <ion-list mode="ios" lines="full">
                    <ion-row llrm>
                        <ion-col size="12" size-md="12">
                            <div class="progress-steps">
                                <ul class="slider">
                                    <li *ngFor="let value of config.possibleValuesGlobalized[language]; let index = index; trackBy: valueTrackBy">
                                        <span [style.color]="config.colors[index] || '#333333'"> {{ value || (('generic.value' | translate) + ' ' + (index + 1)) }} </span>
                                        <div class="circle" [style.borderColor]="config.colors[index] || '#333333'"></div>
                                    </li>
                                </ul>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-list>

                <div class="define-the-names">
                    <h4>{{ 'configBoolean.instructions' | translate }}</h4>
                    <ion-row class="row-values">
                        <ng-container *ngFor="let value of config.possibleValuesGlobalized[language]; let index = index; trackBy: valueTrackBy">
                            <ion-col [size]="2">
                                <ion-item>
                                    <ion-label position="stacked">
                                        {{ 'manageVersion.configRange.globalValue' | translate }} {{ index + 1 }}
                                        <ion-text color="danger" *ngIf="index === 0"> ({{ 'configRange.worstResult' | translate }}) </ion-text>
                                        <ion-text color="primary" *ngIf="index === (config.possibleValues.length - 1)"> ({{ 'configRange.bestResult' | translate }}) </ion-text>
                                        *
                                    </ion-label>
                                    <ion-textarea [(ngModel)]="config.possibleValues[index]"></ion-textarea>
                                </ion-item>
                            </ion-col>
                            <ion-col [size]="2">
                                <ion-item>
                                    <ion-label position="stacked">
                                        {{ 'generic.value' | translate }} {{ index + 1 }}
                                        <ion-text color="danger" *ngIf="index === 0"> ({{ 'configRange.worstResult' | translate }}) </ion-text>
                                        <ion-text color="primary" *ngIf="index === (config.possibleValuesGlobalized[language].length - 1)">
                                            ({{ 'configRange.bestResult' | translate }})
                                        </ion-text>
                                        *
                                    </ion-label>
                                    <ion-textarea [(ngModel)]="config.possibleValuesGlobalized[language][index]"></ion-textarea>
                                </ion-item>
                            </ion-col>
                            <ion-col [size]="3">
                                <ion-item>
                                    <ion-label position="stacked"> {{ 'manageVersion.description' | translate }} - {{ index + 1 }} </ion-label>
                                    <ion-textarea [(ngModel)]="config.description[language][index]"> </ion-textarea>
                                </ion-item>
                            </ion-col>
                            <ion-col [size]="3">
                                <ion-item [lines]="config.confirmationTextEnabled[index] ? null : 'none'" class="has-toggle">
                                    <div class="toggle-container">
                                        <ion-toggle [(ngModel)]="config.confirmationTextEnabled[index]"></ion-toggle>
                                        <ion-label position="stacked"> {{ 'manageVersion.confirmationText' | translate }} - {{ index + 1 }} </ion-label>
                                    </div>
                                    <ion-textarea *ngIf="config.confirmationTextEnabled[index]" [(ngModel)]="config.confirmationText[language][index]"> </ion-textarea>
                                </ion-item>
                            </ion-col>
                            <ion-col [size]="2">
                                <ion-item>
                                    <ion-label position="stacked"> {{ 'generic.color' | translate }} - {{ index + 1 }} </ion-label>
                                    <ion-textarea type="text" [(ngModel)]="config.colors[index]"></ion-textarea>
                                </ion-item>
                            </ion-col>
                        </ng-container>
                    </ion-row>
                </div>
            </mat-tab>
            <mat-tab [label]="'Generic.LimitSettings' | translate">
                <ion-list mode="ios" lines="full">
                    <ion-row llrm>
                        <ion-col size="12" size-md="12">
                            <div class="progress-steps">
                                <ul class="slider">
                                    <li *ngFor="let value of config.possibleValuesGlobalized[language]; let index = index; trackBy: valueTrackBy">
                                        <span [style.color]="config.colors[index] || '#333333'"> {{ value || (('generic.value' | translate) + ' ' + (index + 1)) }} </span>
                                        <div class="circle" [style.borderColor]="config.colors[index] || '#333333'"></div>
                                    </li>
                                </ul>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-list>

                <div class="define-limits">
                    <h4>{{ 'configBooleanLimits.instructions' | translate }}</h4>

                    <ion-row class="row-values">
                        <ng-container *ngFor="let value of config.possibleValuesGlobalized[language]; let index = index; trackBy: valueTrackBy">
                            <ion-col [size]="2">
                                <ion-item class="no-border">
                                    <ion-label position="stacked"> {{ config.possibleValuesGlobalized[language][index] }} </ion-label>
                                    <div class="toggle-container">
                                        <ion-toggle [(ngModel)]="config.valueLimitEnabled[index]"></ion-toggle>
                                        <ion-label position="stacked"> {{ 'configBooleanLimits.enableLimit' | translate }} </ion-label>
                                    </div>
                                </ion-item>
                            </ion-col>
                            <ion-col [size]="2">
                                <ion-item *ngIf="config.valueLimitEnabled[index]">
                                    <ion-label position="stacked"> {{ 'configBooleanLimits.maxLimit' | translate }} </ion-label>
                                    <ion-select [placeholder]="'0'" [(ngModel)]="config.valueLimit[index]">
                                        <ion-select-option *ngFor="let number of [0,1,2,3,4,5,6,7,8,9,10]" [value]="number"> {{ number }} </ion-select-option>
                                    </ion-select>
                                </ion-item>
                            </ion-col>
                            <ion-col [size]="8"> </ion-col>
                        </ng-container>
                    </ion-row>
                </div>
            </mat-tab>
        </mat-tab-group>
    </ion-content>

    <ion-footer mode="ios">
        <ion-toolbar mode="ios">
            <ion-row>
                <ion-col hidden-mobile> </ion-col>
                <ion-col size-md="4">
                    <ion-button color="secondary" expand="block" mode="ios" (click)="save()"> {{ 'generic.save' | translate }} </ion-button>
                </ion-col>
            </ion-row>
        </ion-toolbar>
    </ion-footer>
</div>
